import { ArrowUp, ArrowDown, type LucideIcon } from 'lucide-react';

interface MetricCardProps {
  title: string;
  value: string | number;
  icon: LucideIcon;
  change?: number;
  changeLabel?: string;
  iconBgClass?: string;
  iconClass?: string;
}

export function MetricCard({
  title,
  value,
  icon: Icon,
  change,
  changeLabel = 'vs last month',
  iconBgClass = 'bg-gray-100 dark:bg-gray-800',
  iconClass = 'text-gray-800 dark:text-white/90',
}: MetricCardProps) {
  const isPositive = change !== undefined && change >= 0;
  const hasChange = change !== undefined;

  return (
    <div className="rounded-2xl border border-gray-200 bg-white p-5 dark:border-gray-800 dark:bg-white/[0.03] md:p-6">
      <div className={`flex items-center justify-center w-12 h-12 rounded-xl ${iconBgClass}`}>
        <Icon className={`size-6 ${iconClass}`} />
      </div>

      <div className="flex items-end justify-between mt-5">
        <div>
          <span className="text-sm text-gray-500 dark:text-gray-400">
            {title}
          </span>
          <h4 className="mt-2 font-bold text-gray-800 text-2xl dark:text-white/90">
            {typeof value === 'number' ? value.toLocaleString() : value}
          </h4>
        </div>
        {hasChange && (
          <div
            className={`flex items-center gap-1 px-2 py-1 rounded-full text-sm font-medium ${
              isPositive
                ? 'bg-emerald-100 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-400'
                : 'bg-rose-100 text-rose-700 dark:bg-rose-900/30 dark:text-rose-400'
            }`}
          >
            {isPositive ? (
              <ArrowUp className="w-3 h-3" />
            ) : (
              <ArrowDown className="w-3 h-3" />
            )}
            {Math.abs(change).toFixed(1)}%
          </div>
        )}
      </div>
      {hasChange && (
        <p className="text-xs text-gray-500 dark:text-gray-400 mt-2">
          {changeLabel}
        </p>
      )}
    </div>
  );
}
